module.exports = __webpack_public_path__ + "static/media/promulgation-landing-souvenir.96d4a967.png";